import currencyExchangeMarginRatesApiService from '@/services/api/CurrencyExchangeMarginRates'

const emptyModel = {
  years_in_future: 0,
  rate: 0
}

class CurrencyExchangeMarginRate {
  constructor() {
    this.api = currencyExchangeMarginRatesApiService
    this.emptyModel = emptyModel
  }
}

const currencyExchangeMarginRate = new CurrencyExchangeMarginRate()

export default currencyExchangeMarginRate
